import CallEndIcon from '@mui/icons-material/CallEnd';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import { Tooltip } from '@mui/material';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.error.main,
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        },
        '& .MuiSvgIcon-root': {
            fill: theme.palette.common.white,
        },
        '&.MuiIconButton-root.Mui-disabled': {
            backgroundColor: theme.palette.warning.main,
        },
    },
}));

type Props = Omit<IconButtonProps, 'children'> & {
    customClasses?: string;
};

export default function IconButtonRejectCall({ customClasses = '', disabled, ...props }: Props) {
    const { classes, cx } = useStyles();

    return (
        <Tooltip title="End Call">
            <IconButton
                className={cx(classes.root, customClasses && customClasses)}
                {...props}
                disabled={disabled}
                size="large"
            >
                {disabled ? <PhoneDisabledIcon /> : <CallEndIcon />}
            </IconButton>
        </Tooltip>
    );
}
